module.exports = __webpack_public_path__ + "img/ampc-white-logo.c7d1b4cb.png";